import {
    type FC,
    useId
} from "react";
import {
    View
} from "react-native";
import type IChartKeyProps from "./type";
import stylesheet, {
    getChartKeyMeasures
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import Svg, {
    Rect
} from "react-native-svg";
import {
    CHART_PATTERN_ANGLES,
    getChartSeriesColor
} from "../../util";
import ChartPatternDefs from "../pattern";

const ChartKey: FC<IChartKeyProps> = ({
    pattern = "none",
    shape = "square",
    isOff = false,
    customTheme,
    colorIndex,
    length
}) => {
    const {
        shapeConfigs,
        iconSizes,
        radiuses,
        borders,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const patternID = useId().replace(/[^a-zA-Z0-9]/g, "");

    const measures = getChartKeyMeasures({
        shapeConfigs,
        iconSizes,
        radiuses,
        borders,
        length,
        shape,
        isOff
    });

    const {
        color
    } = getChartSeriesColor({
        colorIndex,
        colors
    });

    const offStroke = borders.line;

    return <View
        style={[
            stylesheet.container,
            {
                height: measures.height,
                width: measures.width
            }
        ]}
        aria-hidden={true}
    >
        <Svg
            height={measures.height}
            width={measures.width}
        >
            <ChartPatternDefs
                customTheme={customTheme}
                id={patternID}
                patterns={[
                    pattern
                ]}
            />
            <Rect
                height={isOff ? measures.height - offStroke : measures.height}
                width={isOff ? measures.width - offStroke : measures.width}
                fill={isOff ? "transparent" : color}
                strokeWidth={isOff ? offStroke : 0}
                stroke={isOff ? color : undefined}
                x={isOff ? offStroke / 2 : 0}
                y={isOff ? offStroke / 2 : 0}
                rx={measures.radius}
            />
            {
                !isOff && CHART_PATTERN_ANGLES[pattern].map((angle) => <Rect
                    fill={`url(#${patternID}-${angle})`}
                    height={measures.height}
                    width={measures.width}
                    rx={measures.radius}
                    key={angle}
                />)
            }
        </Svg>
    </View>;
};
export default ChartKey;
